import React, { Fragment, useState, useEffect } from 'react';
import { Box, Button, Radio, RadioGroup } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ReactMarkdown from 'react-markdown';
import SwipeableViews from 'react-swipeable-views';
import ContentDialog from './ContentDialog';
import CheerGirl from './CheerGirl';

const renderers = {
  text: ({ value }) => (
    <span style={{ fontSize: '1.25rem', fontFamily: 'Itim' }}>
      {value.split('|').map((v, index) => {
        return (
          <Fragment key={index}>
            {index !== 0 && <br />} {v}
          </Fragment>
        );
      })}
    </span>
  ),
  paragraph: ({ children }) => (
    <p style={{ lineHeight: '1rem', marginRight: 16 }}>{children}</p>
  ),
  heading: ({ level, children }) =>
    React.createElement(
      `h${level}`,
      { style: { margin: '2px 0px' } },
      children
    ),
  list: ({ ordered, children }) =>
    ordered ? (
      <ol style={{ margin: 0 }}>{children}</ol>
    ) : (
      <ul style={{ margin: 0, borderBottom: 'dashed 1px #DDD' }}>{children}</ul>
    ),
};

const answers = [3, 2, 1, 2, 1, 4, 1, 1, 2, 3, 2, 2, 3, 4];

const useStyles = makeStyles((theme) => ({
  cheerGirl: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    zIndex: 1,
  },
  contentBox: {
    marginTop: theme.spacing(2),
    paddingTop: 120,
  },
  heading: {
    color: 'white',
    fontSize: '3rem',
    position: 'absolute',
    top: theme.spacing(5),
    left: theme.spacing(2),
    zIndex: 1,
  },
  questionNum: {
    fontFamily: 'Itim',
    fontSize: '1.5rem',
    marginRight: 8,
    marginTop: 8,
  },
  radioGroup: {
    // height: `calc(80vh - ${theme.spacing(25)}px)`,
    overflowY: 'auto',
  },
  radioGroupRoot: {
    flexWrap: 'noWrap',
  },
  submitButton: {
    fontSize: '1.8rem',
  },
}));

const Quiz = ({ onClose }) => {
  const [selected, setSelected] = useState(Array(14).fill(0));
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [showCheer, setShowCheer] = useState(false);
  const {
    cheerGirl,
    contentBox,
    heading,
    questionNum,
    radioGroupRoot,
    submitButton,
    radioGroup,
  } = useStyles();
  const [content, setContent] = useState('');
  const questions = content.split('---');
  useEffect(() => {
    fetch('data/quiz.md').then((res) =>
      res.text().then((data) => setContent(data))
    );
  }, []);
  useEffect(() => {
    if ([1, 4, 9, 12].includes(currentQuestion)) {
      console.log('show cheer');
      setShowCheer(true);
    }
  }, [currentQuestion]);
  return (
    <>
      <ContentDialog
        headerImg={'images/quiz/header.png'}
        footerImg={'images/quiz/footer.png'}
      >
        <div className={heading}>
          VM &amp; Strategies' Quest {currentQuestion + 1}/14
        </div>
        <div className={contentBox}>
          <SwipeableViews index={currentQuestion} disabled={true}>
            {questions.map((question, questionIndex) => {
              return (
                <RadioGroup
                  key={questionIndex}
                  className={radioGroup}
                  classes={{ root: radioGroupRoot }}
                  value={selected[questionIndex]}
                >
                  {question.split('$').map((choice, choiceIndex) =>
                    choiceIndex > 4 ? null : choiceIndex === 0 ? (
                      <Box key={choiceIndex} display="flex">
                        <span className={questionNum}>
                          {questionIndex + 1}.
                        </span>
                        <div>
                          <ReactMarkdown
                            source={choice}
                            renderers={renderers}
                          />
                        </div>
                      </Box>
                    ) : (
                      <Fragment key={choiceIndex}>
                        <Box display="flex" alignItems="center" ml={4}>
                          <Radio
                            size="small"
                            value={choiceIndex}
                            onChange={() =>
                              setSelected(
                                selected.map((_, i) =>
                                  i === questionIndex
                                    ? choiceIndex
                                    : selected[i]
                                )
                              )
                            }
                          />
                          <ReactMarkdown
                            source={choice}
                            renderers={renderers}
                          />
                        </Box>
                        <Box my={0.5} />
                      </Fragment>
                    )
                  )}
                </RadioGroup>
              );
            })}
          </SwipeableViews>
        </div>
        <Box bottom={4} display="flex" justifyContent="center" width="100%">
          <Button
            className={submitButton}
            variant="contained"
            color="primary"
            disabled={selected[currentQuestion] === 0}
            onClick={() => {
              if (currentQuestion === selected.length - 1) {
                onClose(
                  selected
                    .map((i, index) => (i === answers[index] ? 1 : 0))
                    .reduce((acc, val) => acc + val)
                );
              } else {
                setCurrentQuestion(currentQuestion + 1);
              }
            }}
          >
            ส่งข้อมูล
          </Button>
        </Box>
        {showCheer && (
          <CheerGirl className={cheerGirl} onEnd={() => setShowCheer(false)} />
        )}
      </ContentDialog>
    </>
  );
};

export default Quiz;
